import { apiRequest, getResource } from "../api/http";

// Stripe
export function getStripeDetails() {
  return getResource("/api/admin/stripe", {
    select: (data) => data.stripe,
    fallback: [],
  });
}

/** Rejects on failure so the modal can show the API error. */
export function updateStripeDetails(obj, _id) {
  return apiRequest("post", `/api/admin/stripe/connection/${_id}`, {
    data: obj,
    select: (data) => data.stripe,
    rethrow: true,
  });
}

// Bank transfer details (both reject on failure)
export function getBankDetails() {
  return apiRequest("get", "/api/user/bank/get-details", { rethrow: true });
}

export function updateBankDetails(id, obj) {
  return apiRequest("put", `/api/admin/bank/set-details/${id}`, {
    data: obj,
    rethrow: true,
  });
}

// Transactions
export function getTransactions() {
  return getResource("/api/admin/transactions");
}

export function confirmBankSubscription(id) {
  return getResource(`/api/user/bank/subscription-confirm/${id}`);
}

export function confirmBankExclusiveContent(id) {
  return getResource(`/api/user/bank/exclusive-content-confirm/${id}`);
}

export function confirmBankDonation(id) {
  return getResource(`/api/user/bank/donation-confirm/${id}`);
}

export function updatePaymentInfo(id, obj) {
  return apiRequest("put", `/api/user/update-payment-info/${id}`, {
    data: obj,
  });
}

/** Payment methods accepted for new payments: { card: { enabled }, mobile: { enabled, countries } }. */
export function getPaymentMethods() {
  return getResource("/api/admin/payment-methods", { rethrow: true });
}

/** Turns card or Mobile Money payments on or off ({ card?: boolean, mobile?: boolean }). */
export function updatePaymentMethods(changes) {
  return apiRequest("put", "/api/admin/payment-methods", { data: changes, rethrow: true });
}
